import React, { Fragment } from 'react';
import { RightOutlined } from '@ant-design/icons';
import { twMerge } from 'tailwind-merge';

interface Props {
  className?: string;
  breadList: {
    title: string;
    onClick?: () => void;
  }[];
}

export default function BaseBreadcrumb(props: Props) {
  const { breadList, className } = props;
  return (
    <div className={twMerge('font-bold text-lg flex items-center gap-2 flex-wrap', className)}>
      {breadList?.map((bread, index) => {
        return (
          <Fragment key={index}>
            <div
              onClick={bread.onClick}
              className={`cursor-pointer ${
                index < breadList?.length - 1
                  ? 'text-gray_800 font-semibold text-xl'
                  : 'text-gray_500 font-semibold text-xl'
              }`}
            >
              {bread?.title}
            </div>
            {index < breadList?.length - 1 && <RightOutlined className="w-5" />}
          </Fragment>
        );
      })}
    </div>
  );
}
